export default {
    childrenStyles: {
        overflow: "visible",
        padding: "0px 40px 25px 40px",
    },

    buttonsContainer: {
        marginTop: "40px"
    },

    dropdownMenu: {
        width: "100%",
    }
}